import { ThunkType } from "../../../../core/store/reducers";
import { getAntiLaunderingExcel } from "../api/getAntiLaunderingExcel";
import fileDownload from "js-file-download";
import { setFetchState } from "../amlaunderingDataSlice";

export const downloadAntiMnyLndCommExcel = (): ThunkType => async (
  dispatch,
  getStore
) => {
  const store = getStore();

  if (store.data.auth.current.status !== "successful") {
    return undefined;
  }

  const { filter } = store.ux.reports.antiLaundering;
  const user = store.data.auth.current.user;
  dispatch(setFetchState({ type: "started" }));
  const dailyTrading = await dispatch(getAntiLaunderingExcel(user, filter));
  if (dailyTrading) {
    fileDownload(
      new Blob([dailyTrading as any], {
        type: "application/vnd.openxmlformat",
      }),
      "AntiMnyLndComm.xlsx"
    );
  }
  dispatch(setFetchState({ type: "not-started" }));
};
